import { stateOptions } from '../commonStateTaxData';

export const basicInfo = [
  {
    id: 'employee_name',
    title: 'Full name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '\\d{5}',
      },
    ],
  },
];

export const maritalStatus = [
  {
    id: 'marital_status',
    title: 'What is your marital status?',
    is_required: true,
    question_type: 'multiple_choice',
    options: [
      {
        codeValue: 'single',
        shortName: 'Single',
      },
      {
        codeValue: 'married',
        shortName: 'Married',
      },
    ],
  },
];

export const claimExemptionsOptions = {
  single: [
    {
      id: 'single_claim_exemption',
      title: 'Individuals are permitted a maximum of one exemption for themselves, plus any dependent other than their spouse that they expect to claim of their tax return (Line 1)',
      question_type: 'long_multiple_choice',
      is_required: true,
      options: [
        {
          codeValue: '1_exemption',
          shortName: 'Select this option to claim an exemption for yourself',
        },
        {
          codeValue: '0_exemptions',
          shortName: 'Select this option if you do not want to claim an exemption for yourself',
        },
      ],
    },
  ],
  married: [
    {
      id: 'married_claim_exemption',
      title: 'Individuals are permitted a maximum of one exemption for themselves, plus an additional exemption for their spouse and any dependent other than their spouse that they expect to claim of their tax return (Line 2)',
      question_type: 'long_multiple_choice',
      is_required: true,
      options: [
        {
          codeValue: '1_exemption',
          shortName: 'Select this option to claim one of these exemptions for either yourself or your spouse',
        },
        {
          codeValue: '2_exemptions',
          shortName: 'Select this option to claim both of these exemptions for yourself and your spouse.',
        },
        {
          codeValue: '0_exemptions',
          shortName: 'Select this option to claim neither of these exemptions.',
        },
      ],
    },
  ],
};

export const additionalExemptions = [
  {
    id: 'exemptions_for_dependents',
    title: 'If you claim exemptions for one or more dependents, enter the number of such exemptions (Line 3)',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
  {
    id: 'additional_withholding',
    title: 'Enter any additional withholding per pay period under agreement with employer. (Line 6)',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];
